// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2mFR7","title":"Info_title__stheh","selects":"Info_selects__XtG6r","requiredAsterisk":"Info_requiredAsterisk__2dIuc"};